import { useMutation } from '@tanstack/react-query';
import { removeMFARegisteredDevice } from '../services/fn-api/User';

export const useRemoveMFARegisteredDevice = () => {
  return useMutation<void, Error>({
    mutationFn: async () => {
      return removeMFARegisteredDevice();
    },
  });
};
